import { Icon } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { EmptyValue } from './EmptyValue';

export function BooleanDisplay() {
  const { value } = useFieldContext();
  if (typeof value !== 'boolean') {
    return <EmptyValue />;
  }
  return (
    <span className="inline-flex items-center gap-1.5">
      <Icon
        name={value ? 'success' : 'close'}
        size="0.9rem"
        className={value ? 'text-success' : 'text-ink-subtle'}
      />
      {value ? 'Yes' : 'No'}
    </span>
  );
}
